// import { createContext, useContext } from "react";


// const AppContext = createContext();

// const AppProvider = ({children}) => {

//     return <AppContext.Provider>
//         {/* value={{}} */}
//         {children}
//     </AppContext.Provider>
// }

// const useGlobalContext = () => {
//     return useContext(AppContext);
// }

// export {AppProvider, useGlobalContext};

import { createContext, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import dbRooms from './utils/dbRooms';

const AppContext = createContext();

const AppProvider = ({ children }) => {
    const { i18n } = useTranslation();
    const [language, setLanguage] = useState(i18n.language);
    const [rooms, setRooms] = useState(dbRooms);

    const changeLanguage = () => {
        const newLanguage = language === "en" ? "it" : "en";
        setLanguage(newLanguage);
        i18n.changeLanguage(newLanguage);
    };

    return (
        <AppContext.Provider value={{ language, changeLanguage, rooms, setRooms }}>
            {children}
        </AppContext.Provider>
    );
};

const useGlobalContext = () => {
    return useContext(AppContext);
};

export { AppProvider, useGlobalContext };
